module.exports = ({ ip, country, countryName }) => {
	window.userData = {
		ip,
		country,
		countryName,
		referrer: document.referrer,
	};
};
